import bidSuccessImgPath from 'assets/pngs/bid-success.png';
import { Button, DialogActions } from 'ui-kit';

export interface BidSucceededDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const BidSucceededDialog: React.FC<BidSucceededDialogProps> = ({ onConfirm, onCancel }) => {
  return (
    <>
      <div className="mb-2 flex justify-center">
        <img src={bidSuccessImgPath} width={233} height={232} alt="bid succeeded" />
      </div>
      <div className=" text-center text-[24px] font-medium leading-[36px] text-white">
        Your Bid was successful!
      </div>
      <div className="w-[290px]">
        Would you like to track your bid or return back to the Marketplace?
      </div>
      <DialogActions>
        <Button type="secondary" size="medium" label="cancel" onClick={() => onCancel()}>
          Back to Deal
        </Button>
        <Button size="medium" className="font-bold" label="confirm" onClick={() => onConfirm()}>
          Return to Active Trades
        </Button>
      </DialogActions>
    </>
  );
};
